import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { ShareDTO } from 'markets-lib';

import { config } from '../config';
import { prepHeaders } from '../util';

interface ExtraParameters {
  contractId: string;
}

export const sharesApi = createApi({
  reducerPath: 'shares',
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: prepHeaders,
  }),
  tagTypes: ['Shares', 'Contracts'],
  endpoints: (builder) => ({
    upsert: builder.mutation<ShareDTO & ExtraParameters, ShareDTO>({
      query: (payload) => ({
        url: '/api/shares',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Shares', 'Contracts'],
    }),
    getById: builder.query<ShareDTO, ShareDTO['id']>({
      query: (id) => `/api/shares/${id}`,
      providesTags: ['Shares', 'Contracts'],
    }),
    remove: builder.mutation<ShareDTO, ShareDTO['id']>({
      query: (id) => ({
        url: `/api/shares/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Shares', 'Contracts'],
    }),
  }),
});

export const { endpoints, middleware, reducer, reducerPath, useUpsertMutation, useRemoveMutation, useGetByIdQuery } =
  sharesApi;
